const moduleName = "project/";
module.exports.id = {
    id: "CONTRACT_MGT_CLIENT_DETAILS",
    method: "POST",
    name: "客户合同明细",
    type: "menu_hide"
};

// let moduleName = ''

module.exports.children = {};
